const DEFAULT_ZONES = {
  italy: {
    label: 'Italia',
    free_shipping_min: 0,
    shipping_cost: 0,
  },
  eu: {
    label: 'Unione Europea',
    free_shipping_min: 0,
    shipping_cost: 0,
  },
  world: {
    label: 'Resto del mondo',
    free_shipping_min: 0,
    shipping_cost: 0,
  },
};

const ITALIA_ALIASES = ['italia', 'italy', 'it', 'repubblica italiana'];

const EU_ALIASES = [
  'austria', 'belgio', 'belgium', 'bulgaria', 'croazia', 'croatia',
  'cipro', 'cyprus', 'repubblica ceca', 'czech republic', 'danimarca', 'denmark',
  'estonia', 'finlandia', 'finland', 'francia', 'france', 'germania', 'germany',
  'grecia', 'greece', 'irlanda', 'ireland', 'letonia', 'latvia', 'lituania', 'lithuania',
  'lussemburgo', 'luxembourg', 'malta', 'paesi bassi', 'netherlands', 'olanda',
  'polonia', 'poland', 'portogallo', 'portugal', 'romania', 'slovacchia', 'slovakia',
  'slovenia', 'spagna', 'spain', 'svezia', 'sweden', 'ungheria', 'hungary',
  'europa', 'europe', 'ue', 'eu',
];

export const SHIPPING_ZONE_KEYS = ['italy', 'eu', 'world'];

export const ZONE_LABELS = {
  italy: DEFAULT_ZONES.italy.label,
  eu: DEFAULT_ZONES.eu.label,
  world: DEFAULT_ZONES.world.label,
};

export function getDefaultZones() {
  return JSON.parse(JSON.stringify(DEFAULT_ZONES));
}

export function normalizeZoneKey(zone) {
  if (!zone) return 'italy';
  const key = zone.toLowerCase();
  return SHIPPING_ZONE_KEYS.includes(key) ? key : 'italy';
}

export function detectShippingZone(countryInput) {
  const value = (countryInput || '').trim().toLowerCase();
  if (!value) return 'italy';

  if (ITALIA_ALIASES.includes(value)) {
    return 'italy';
  }

  if (EU_ALIASES.includes(value)) {
    return 'eu';
  }

  return 'world';
}

export function getZoneSettings(settings, zoneKey) {
  const zones = settings?.zones || settings || {};
  const key = normalizeZoneKey(zoneKey);
  return zones[key] || DEFAULT_ZONES[key];
}


